import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined } from '@ant-design/icons';

import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin
} from "antd";

import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from '../../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from '../../../../../../components/custom/CustomButton';
import dayjs from "dayjs";
import TextArea from 'antd/es/input/TextArea';
import { elements } from 'chart.js';

const { Text } = Typography

const Foreclosure = (props) => {

  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const dateFormat = 'YYYY/MM/DD';

  useEffect(() => {
    getTemplate();
    getTransactonsTemplate()
  }, []);


  const defaultDate = () => {
    useForm.setFieldsValue({
      transactionDate: dayjs(),
    })
  }
  function getTemplate() {

    const params = {
      associations: "all"
    }

    const url = `${apiConfig.Loans}/${state.id}`

    let body = {
      session,
      params
    };

    BOM.FetchReqAction(body, url, (err, res) => {

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
      }
    });
  }

  function getTransactonsTemplate() {

    const params = {
      command: "foreclosure",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      transactionDate: defaultDate()
    }

    const url = `${apiConfig.Loans}/${state.id}/transactions/template`

    let body = {
      session,
      params
    };

    BOM.FetchReqAction(body, url, (err, res) => {

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;

        useForm.setFieldsValue({
          outstandingPrincipalPortion: objList?.principalPortion,
          outstandingInterestPortion: objList?.interestPortion,
          outstandingFeeChargesPortion: objList?.feeChargesPortion,
          outstandingPenaltyChargesPortion: objList?.penaltyChargesPortion,
          transactionAmount: objList?.amount,

        });
      }
    });
  }

  function onCancel() {
    navigate("/detail-group-loan", { state: state });
  }

  const onSubmit = (formValues) => {


    formValues.transactionDate = BOM.DateTime(formValues.transactionDate, "only-date")

    delete formValues.outstandingFeeChargesPortion
    delete formValues.outstandingInterestPortion
    delete formValues.outstandingPenaltyChargesPortion
    delete formValues.outstandingPrincipalPortion
    delete formValues.transactionAmount

    const params = {
      command: "foreclosure"
    }

    const url = `${apiConfig.Loans}/${state.id}/transactions`

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      session,
      params
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.foreClosureMsg);
        navigate("/detail-group-loan", { state: state });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
  return (

    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.foreClosure}
        pageItems={staticConfig.foreClosureBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >

            <Row >
              <Divider />

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.transactionDate}
                    name={"transactionDate"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(
                          labelConfig.transactionDate
                        ),
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.transactionDate}`,
                        "select"
                      )}
                      style={{ width: '100%' }}
                      format={dateFormat}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.principal}
                    name={"outstandingPrincipalPortion"}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.principal
                      )}
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.interest}
                    name={"outstandingInterestPortion"}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.interest
                      )}
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.feeAmount}
                    name={"outstandingFeeChargesPortion"}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.feeAmount
                      )}
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.penaltyAmount}
                    name={"outstandingPenaltyChargesPortion"}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.penaltyAmount
                      )}
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.transactionAmount}
                    name={"transactionAmount"}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.transactionAmount
                      )}
                      disabled
                    />
                  </Form.Item>
                </Col>

                <Divider orientation="left" orientationMargin="0"></Divider>


                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.note}
                    name={"note"}
                  >
                    <TextArea style={{ width: "100%", height: "10vh" }} placeholder='Please enter a note' />

                  </Form.Item>
                </Col>

              </Row>

            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("FORECLOSURE_LOAN") &&
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#15CCAE"
                  colorText="black"
                  hoverBackground="#4FECA0"
                />}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>

        </Card>
      </Spin>

    </MainLayout>
  )
}

export default Foreclosure